import React, { useState, useEffect, useCallback } from "react";
import TotGameOption from "./totGameOption";
import TotGame from "./totGame";
import HowToPlay from "./howToPLay";
import Socket from "../../socket/socket";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";

const TotMain = (props) => {
  const [timer, setTimer] = useState("60");
  const [isDoubleRounds, setDoubleRounds] = useState(false);
  const roomData = _.get(props.gameReducer, "roomObj");
  let isDoubleRoundsForMapp = _.get(roomData, "lobby_parameters.double_rounds", false);

  const handleTimerChange = useCallback(
    (value) => {
      setTimer(value);
    },
    [timer]
  );

  const handleDoubleRoundsChange = useCallback(
    (value) => {
      setDoubleRounds(value);
    },
    [isDoubleRounds]
  );
  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      timer: timer,
    };
    Socket.sendMessage(data);
  }, [timer]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      double_rounds: isDoubleRounds,
    };
    Socket.sendMessage(data);
  }, [isDoubleRounds]);

  // const [howtoplay_modal, set_howtoplay_modal] = useState(false);
  // const toggle_how_to_play_modal = () => {
  //   set_howtoplay_modal(!howtoplay_modal);
  // };
  return (
    <>
      {props.howtoplay_modal ? (
        <HowToPlay toggle_how_to_play_modal={props.toggle_how_to_play_modal} />
      ) : (
        <>
          <TotGame usersChanged={props.usersChanged} />
          <TotGameOption
            toggle_how_to_play_modal={props.toggle_how_to_play_modal}
            isDoubleRoundsForMapp={isDoubleRoundsForMapp}
            timer={timer}
            onTimerChange={handleTimerChange}
            isDoubleRounds={isDoubleRounds}
            onDoubleRoundsChange={handleDoubleRoundsChange}
          />
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

export default compose(withRouter, connect(mapStateToProps))(TotMain);
